// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  ======================
    Component styles on page load
    ====================== */

@keyframes Spinner_spin__ngnlQ {
	to {
    	transform: rotate(1turn);
    }
}

.Spinner_spinner__LSSBW {
	position: relative;
	display: inline-block;
	vertical-align: middle;
	width: 5em;
	height: 5em;
	margin: 0 .5em;
	font-size: 8px;
	text-indent: 999em;
	overflow: hidden;
	animation: Spinner_spin__ngnlQ 1s infinite steps(8);
}

.Spinner_spinner__LSSBW.Spinner_small__25bLT {
	font-size: 3px;
}

.Spinner_spinner__LSSBW.Spinner_large__\\+Bw0c {
	font-size: 12px;
}

.Spinner_spinner__LSSBW:before,
.Spinner_spinner__LSSBW:after,
.Spinner_spinner__LSSBW > div:before,
.Spinner_spinner__LSSBW > div:after {
	content: '';
	position: absolute;
	top: 0.25em;
	left: 2.25em; /* (container width - part width)/2 */
	width: .5em;
	height: 1em;
	border-radius: .2em;
	background: var(--color-118);
	background: rgba(0,0,0,0.2);
	box-shadow: 0 3.5em var(--color-118); /* container height - part height */
	box-shadow: 0 3.5em rgba(0,0,0,0.2); /* container height - part height */
	transform-origin: 50% 2.25em; /* container height / 2 */
}

.Spinner_spinner__LSSBW:before {
	background: var(--color-101);
	background: rgba(0,0,0,0.8);
}

.Spinner_spinner__LSSBW:after {
	transform: rotate(-45deg);
	background: var(--color-113);
	background: rgba(0,0,0,0.65);
}

.Spinner_spinner__LSSBW > div:before {
	transform: rotate(-90deg);
	background: var(--color-113);
	background: rgba(0,0,0,0.5);
}

.Spinner_spinner__LSSBW > div:after {
	transform: rotate(-135deg);
	background: var(--color-119);
	background: rgba(0,0,0,0.35);
}

.Spinner_spinner__LSSBW.Spinner_reverse__OwlqM:before,
.Spinner_spinner__LSSBW.Spinner_reverse__OwlqM:after,
.Spinner_spinner__LSSBW.Spinner_reverse__OwlqM > div:before,
.Spinner_spinner__LSSBW.Spinner_reverse__OwlqM > div:after {
	background: rgba(255,255,255,0.4); /* container height - part height */
	box-shadow: 0 3.5em rgba(255,255,255,0.4); /* container height - part height */
}

.Spinner_spinner__LSSBW.Spinner_reverse__OwlqM:before {
	background: rgba(255,255,255,1);
}

.Spinner_spinner__LSSBW.Spinner_reverse__OwlqM:after {
	background: rgba(255,255,255,0.8);
}

.Spinner_spinner__LSSBW.Spinner_reverse__OwlqM > div:before {
	background: rgba(255,255,255,0.6);
}

.Spinner_spinner__LSSBW.Spinner_reverse__OwlqM > div:after {
	background: rgba(255,255,255,0.5);
}

.Spinner_spinner__LSSBW.Spinner_blue__hGkvu:before,
.Spinner_spinner__LSSBW.Spinner_blue__hGkvu:after,
.Spinner_spinner__LSSBW.Spinner_blue__hGkvu > div:before,
.Spinner_spinner__LSSBW.Spinner_blue__hGkvu > div:after {
	background: rgba(17,169,237,0.4); /* container height - part height */
	box-shadow: 0 3.5em rgba(17,169,237,0.4); /* container height - part height */
}

.Spinner_spinner__LSSBW.Spinner_blue__hGkvu:before {
	background: rgba(17,169,237,1);
}

.Spinner_spinner__LSSBW.Spinner_blue__hGkvu:after {
	background: rgba(17,169,237,0.8);
}

.Spinner_spinner__LSSBW.Spinner_blue__hGkvu > div:before {
	background: rgba(17,169,237,0.6);
}

.Spinner_spinner__LSSBW.Spinner_blue__hGkvu > div:after {
	background: rgba(17,169,237,0.5);
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Spinner/Spinner.module.css"],"names":[],"mappings":"AAAA;;4BAE4B;;AAE5B;CACC;KACI,wBAAwB;IACzB;AACJ;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,UAAU;CACV,WAAW;CACX,cAAc;CACd,cAAc;CACd,kBAAkB;CAClB,gBAAgB;CAChB,mDAAoC;AACrC;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,eAAe;AAChB;;AAEA;;;;CAIC,WAAW;CACX,kBAAkB;CAClB,WAAW;CACX,YAAY,EAAE,qCAAqC;CACnD,WAAW;CACX,WAAW;CACX,mBAAmB;CACnB,4BAA4B;CAC5B,2BAA2B;CAC3B,oCAAoC,EAAE,mCAAmC;CACzE,mCAAmC,EAAE,mCAAmC;CACxE,4BAA4B,EAAE,yBAAyB;AACxD;;AAEA;CACC,4BAA4B;CAC5B,2BAA2B;AAC5B;;AAEA;CACC,yBAAyB;CACzB,4BAA4B;CAC5B,4BAA4B;AAC7B;;AAEA;CACC,yBAAyB;CACzB,4BAA4B;CAC5B,2BAA2B;AAC5B;;AAEA;CACC,0BAA0B;CAC1B,4BAA4B;CAC5B,4BAA4B;AAC7B;;AAEA;;;;CAIC,iCAAiC,EAAE,mCAAmC;CACtE,yCAAyC,EAAE,mCAAmC;AAC/E;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;;;;CAIC,gCAAgC,EAAE,mCAAmC;CACrE,wCAAwC,EAAE,mCAAmC;AAC9E;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,gCAAgC;AACjC","sourcesContent":["/*  ======================\n    Component styles on page load\n    ====================== */\n\n@keyframes spin {\n\tto {\n    \ttransform: rotate(1turn);\n    }\n}\n\n.spinner {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\twidth: 5em;\n\theight: 5em;\n\tmargin: 0 .5em;\n\tfont-size: 8px;\n\ttext-indent: 999em;\n\toverflow: hidden;\n\tanimation: spin 1s infinite steps(8);\n}\n\n.spinner.small {\n\tfont-size: 3px;\n}\n\n.spinner.large {\n\tfont-size: 12px;\n}\n\n.spinner:before,\n.spinner:after,\n.spinner > div:before,\n.spinner > div:after {\n\tcontent: '';\n\tposition: absolute;\n\ttop: 0.25em;\n\tleft: 2.25em; /* (container width - part width)/2 */\n\twidth: .5em;\n\theight: 1em;\n\tborder-radius: .2em;\n\tbackground: var(--color-118);\n\tbackground: rgba(0,0,0,0.2);\n\tbox-shadow: 0 3.5em var(--color-118); /* container height - part height */\n\tbox-shadow: 0 3.5em rgba(0,0,0,0.2); /* container height - part height */\n\ttransform-origin: 50% 2.25em; /* container height / 2 */\n}\n\n.spinner:before {\n\tbackground: var(--color-101);\n\tbackground: rgba(0,0,0,0.8);\n}\n\n.spinner:after {\n\ttransform: rotate(-45deg);\n\tbackground: var(--color-113);\n\tbackground: rgba(0,0,0,0.65);\n}\n\n.spinner > div:before {\n\ttransform: rotate(-90deg);\n\tbackground: var(--color-113);\n\tbackground: rgba(0,0,0,0.5);\n}\n\n.spinner > div:after {\n\ttransform: rotate(-135deg);\n\tbackground: var(--color-119);\n\tbackground: rgba(0,0,0,0.35);\n}\n\n.spinner.reverse:before,\n.spinner.reverse:after,\n.spinner.reverse > div:before,\n.spinner.reverse > div:after {\n\tbackground: rgba(255,255,255,0.4); /* container height - part height */\n\tbox-shadow: 0 3.5em rgba(255,255,255,0.4); /* container height - part height */\n}\n\n.spinner.reverse:before {\n\tbackground: rgba(255,255,255,1);\n}\n\n.spinner.reverse:after {\n\tbackground: rgba(255,255,255,0.8);\n}\n\n.spinner.reverse > div:before {\n\tbackground: rgba(255,255,255,0.6);\n}\n\n.spinner.reverse > div:after {\n\tbackground: rgba(255,255,255,0.5);\n}\n\n.spinner.blue:before,\n.spinner.blue:after,\n.spinner.blue > div:before,\n.spinner.blue > div:after {\n\tbackground: rgba(17,169,237,0.4); /* container height - part height */\n\tbox-shadow: 0 3.5em rgba(17,169,237,0.4); /* container height - part height */\n}\n\n.spinner.blue:before {\n\tbackground: rgba(17,169,237,1);\n}\n\n.spinner.blue:after {\n\tbackground: rgba(17,169,237,0.8);\n}\n\n.spinner.blue > div:before {\n\tbackground: rgba(17,169,237,0.6);\n}\n\n.spinner.blue > div:after {\n\tbackground: rgba(17,169,237,0.5);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinner": `Spinner_spinner__LSSBW`,
	"spin": `Spinner_spin__ngnlQ`,
	"small": `Spinner_small__25bLT`,
	"large": `Spinner_large__+Bw0c`,
	"reverse": `Spinner_reverse__OwlqM`,
	"blue": `Spinner_blue__hGkvu`
};
export default ___CSS_LOADER_EXPORT___;
